import React from "react";
import {FormControl, InputLabel, Select, MenuItem} from "@material-ui/core";

import {
  WorkflowTask,
  WorkflowTaskId,
} from "common/flowmaster/types/task_config";

interface TaskSelectorProps {
  task: WorkflowTaskId;
  tasks: WorkflowTask[];
  onSetTask: (value: WorkflowTaskId) => void;
  disabled?: boolean;
}
const TaskSelector: React.FC<TaskSelectorProps> = ({
  task,
  tasks,
  onSetTask,
  disabled = false,
}) => {
  return (
    <FormControl disabled={disabled} variant="outlined" fullWidth>
      <InputLabel id="task-selector-label">Action</InputLabel>
      <Select
        labelId="task-selector-label"
        value={task}
        onChange={event => onSetTask(event.target.value as WorkflowTaskId)}
        label="Task"
        error={!task}
      >
        {(tasks ?? []).map(_task => (
          <MenuItem value={_task.id} key={_task.id}>
            {_task.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TaskSelector;
